<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="AlertIcon" alt="Alert Icon" width="40" height="40" />
      </div>
      <h4>{{ deleteConfirmTitle }}</h4>
      <p class="m-0 text-muted" v-html="deleteConfirmDescription"></p>
    </div>
    <template #modal-footer>
      <div class="d-flex gap-3 w-100">
        <b-button
            :disabled="loading"
            class="w-50"
            variant="light"
            @click="handleCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
        <b-button
            :disabled="loading"
            class="w-50 m-0"
            variant="danger"
            @click="handleConfirm"
        >
          <b-spinner v-if="loading" class="me-2" small></b-spinner>
          {{ lodash.startCase($t('purchase_plans.buttons.delete')) }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import AlertIcon from '@/assets/icons/AlertIcon.svg'
import Swal from 'sweetalert2'

export default {
  name: 'purchase-plan-delete-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-delete-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      AlertIcon,
      loading: false,
      targetModel: null,
    };
  },
  computed: {
    targetModelKey() {
      return this.targetModel?.id ?? null
    },
    deleteConfirmTitle() {
      return `${this.$t('purchase_plans.modal_messages.confirm_delete_title')}?`
    },
    deleteConfirmDescription() {
      const description = this.$t('purchase_plans.modal_messages.{something}_confirm_delete_description')
      const safeSomething = this.lodash.escape(this.targetModelKey)

      return description.replace('{something}', `<strong>${safeSomething}</strong>`)
    },
  },
  methods: {
    show(model) {
      this.targetModel = model ?? null
      this.$bvModal.show(this.id)
    },
    handleCancel() {
      if (this.loading) return
      this.hide()
    },
    handleConfirm() {
      const targetModel = this.targetModel
      this.loading = true

      return this.$axios.delete(`/v1/purchase_plans/${targetModel.id}`)
          .then(() => {
            this.hide()
            this.$emit('deleted', targetModel.id)
          })
          .catch((error) => {
            return Swal.fire({
              title: this.$t('Failed') + '!',
              text: (error.response && (error.response.data || {}).message) || error.message,
              type: 'danger',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
